import api from '../../api'
const state = {
    list: [],
    page: 1,
    perPage: 10,
    total: 0,
    pages: 0,
    query: null
}

const mutations = {
    SET_RECIPES (state, value) {
        state.list = value
    },
    DELETE_RECIPE (state, value) {
        state.list.splice(state.list.indexOf(value), 1)
    },
    SET_PAGE (state, value) {
        state.page = value
    },
    SET_TOTAL (state, value) {
        state.total = value
        state.pages = Math.ceil(state.total / state.perPage)
    },
    UPDATE_SEARCH_QUERY (state, value) {
        state.query = value
    }
}

const actions = {
    loadRecipes ({commit, dispatch, state, rootState}, page) {
        commit('SET_PAGE', page || 1)
        dispatch('Global/setLoading', true, {root: true})
        axios.post(rootState.Settings.apiUrl + '/recipe/load', {perPage: state.perPage, page: state.page, query: state.query})
            .then(function (response) {
                commit('SET_TOTAL', response.data.pagination.total)
                commit('SET_RECIPES', response.data.data)
                dispatch('Global/setLoading', false, {root: true})
            })
    },
    async deleteRecipe ({commit, dispatch, state, rootState}, data) {
        axios.delete(rootState.Settings.apiUrl + '/recipe/delete/' + data.id)
            .then(function (response) {
                //commit('DELETE_RECIPE', data)
                dispatch('loadRecipes', state.page)
            })
    },
    async duplicateRecipe ({commit, rootState}, data) {
        return new Promise((resolve, reject) => {
            axios.get(rootState.Settings.apiUrl + '/recipe/duplicate/' + data.id)
                .then(function (response) {
                    resolve(response.data)
                })
        })
    },
    updateSearchQuery ({commit}, query) {
        commit('UPDATE_SEARCH_QUERY', query)
    },
    search ({dispatch, state}) {
        dispatch('loadRecipes', state.page)
    }
}

const getters = {
    nutrition: (state, getters, rootState) => (index, type) => {
        return api.getTotalNutrition(type, state.list[index].servings, state.list[index].ingredient_lists, rootState.Streams.stream)
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
